import React, { useState } from 'react';
import DriverSidebar from '../components/DriverSidebar';
import DashboardHeader from '../components/DashboardHeader';
import ProfileCompletionBanner from '../components/ProfileCompletionBanner';

/** Layout Chauffeur (sidebar mobile-first, background gray-100). */
export const DriverLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <DriverSidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <div className="lg:ml-64 transition-all duration-300">
        <DashboardHeader onMenuClick={() => setMobileOpen(true)} />
        <main className="pt-16 sm:pt-20 p-3 sm:p-6">
          <ProfileCompletionBanner />
          {children}
        </main>
      </div>
    </div>
  );
};
